import AppApi from '@app/api/index';

export interface DashboardData {
  agents: number;
  facilities: number;
  facilitiesActive: number;
  facilitiesNew30: number;
  developers: number;
  managers: number;
  owners: number;
}

export default class StatisticsApi {
  constructor(private readonly api: AppApi) {}

  getDashboard(): Promise<DashboardData> {
    return this.api.client.get<null, DashboardData>('/statistics/dashboard');
  }
}
